var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import "./alert-social-feed-sidebar.sass";
import { CheckboxColors } from "../../../utils/common/common";
import Checkbox, {
  CheckboxButtonType
} from "../../../../../../../../../components/interface/inputs/checkbox-button/checkbox-button";
export const AlertSocialFeedSidebar = (_a) => {
  var _b = _a, { onStatusChange, defaultChecked, id, name } = _b, rest = __objRest(_b, ["onStatusChange", "defaultChecked", "id", "name"]);
  return /* @__PURE__ */ React.createElement("div", { className: "tint-alert-social-feed-sidebar" }, /* @__PURE__ */ React.createElement(
    Checkbox,
    __spreadValues({
      key: id,
      color: CheckboxColors.WHITE,
      borderColor: CheckboxColors.BLUE,
      backgroundColor: CheckboxColors.WHITE,
      markColor: CheckboxColors.BLUE,
      id,
      name,
      defaultChecked,
      onStatusChange,
      type: CheckboxButtonType.PRIMARY
    }, rest)
  ), /* @__PURE__ */ React.createElement("p", { className: "tint-alert-social-feed-sidebar__label" }, "I would like to manually approve posts before they appear publicly on my TINT."));
};
